<template>
  <div class="footer-bg">
    <div class="footer-box">
      <div class="footer-left">
        <ul class="footer-list">
          <li><el-link href="/Index/Wjsproviders.html">关于我们</el-link></li>
          <li><el-link href="/about/contactus.html">联系我们</el-link></li>
          <li><el-link href="/zt/zxdsj/">发展历程</el-link></li>
          <li><el-link href="/Index/Wjsproviders.html">产品服务</el-link></li>
          <li><el-link>网经社 版权所有</el-link></li>
        </ul>
      </div>
      <!-- <div class="footer-right">
        <img src="http://www.100ec.cn/Public/home/images/wjbewm.jpg" alt="" />
        <img src="../assets/ewm.jpg" alt="" />
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
    name: 'Footer',
    data() {
        return {
            list: [
                {
                    name: '关于我们',
                    url: '/Index/Wjsproviders.html'
                },
                {
                    name: '联系我们',
                    url: '/about/contactus.html'
                },
                {
                    name: '发展历程',
                    url: '/zt/zxdsj/'
                },
                {
                    name: '产品服务',
                    url: '/Index/Wjsproviders.html'
                },
                {
                    name: '网经社 版权所有',
                    url: '/'
                },
            ]
        }
    }
}
</script>

<style scoped>
.footer-bg {
  width: 100%;
  background: #222;
  padding: 30px 0 10px 0;
}
.footer-box {
  /* display: flex; */
  max-width: 900px;
  margin: auto;
}
.footer-left {
  border-bottom: #313131 solid 1px;
}
.footer-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.footer-list li:nth-child(5) {
  flex: 0 0 100%;
}

.footer-list .el-link {
  position: relative;
  padding: 10px 20px;
}

.footer-list .el-link:hover {
  color: #fff;
}

.footer-list .el-link::after {
  content: "丨";
  color: #666;
  position: absolute;
  right: -6px;
}

.footer-list li:nth-child(5) {
  text-align: center;
}

.footer-list li:nth-child(4) .el-link::after,
.footer-list li:nth-child(5) .el-link::after {
  content: "";
}

.footer-right img {
  width: 110px;
  display: inline-block;
  margin: 10px 20px;
}

@media (max-width: 1100px) {
  .footer-list .el-link {
    padding: 10px;
  }
  .footer-right img {
    width: 60px;
    margin: 5px;
  }
}
</style>
